import React, { useEffect } from "react";
import './css/index.scss';

import { } from '@lockerpm/design';

import commonComponents from "../../components/common";

import global from "../../config/global";

const Register = () => {
  const { BusyOverlay } = commonComponents;

  useEffect(() => {
    window.location.replace(`${global.urls.LOCKER_ID_URL}/register?SERVICE_URL=/&SERVICE_SCOPE=${global.constants.SERVICE_SCOPE}&ENVIRONMENT=${global.constants.ENVIRONMENT}`)
  }, [])

  return (
    <div className="auth-page">
      <BusyOverlay />
    </div>
  );
}

export default Register;